/**
 * @author taulmax
 * @date 2024.10.07
 * @description 레이아웃 메인 컨텐츠 컴포넌트
 */
const Main = ({ component }: { component?: React.ReactNode }) => {
  return (
    <div className="!h-full !w-full">
      {component}
    </div>
  );
};

export default Main;
